import { render, staticRenderFns } from "./NavColor.vue?vue&type=template&id=c8146386&"
import script from "./NavColor.vue?vue&type=script&lang=js&"
export * from "./NavColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports